import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Avatar, Button, Stack } from "@mui/material";
import Box from "@mui/material/Box";
import React,{useState} from "react";
import "./Header.css";
import { Search, SentimentDissatisfied } from "@mui/icons-material";
import {
  CircularProgress,
  Grid,
  InputAdornment,
  TextField,
} from "@mui/material";
import { useHistory, useLocation,Link ,Redirect} from "react-router-dom";
import Products from "./Products";

const Header = ({ children, hasHiddenAuthButtons }) => {
  const history=useHistory();
  const location=useLocation();
  const [search,setSearch]=useState("");
  const handleClick=()=>{
    history.push("/",{from:location.pathname})
  }
  const logout=()=>{
    localStorage.removeItem("username")
      localStorage.removeItem("token")
      localStorage.removeItem("balance")
      history.push("/")
      window.location.reload()
  }
  // const handleChange=name=>event=>{
  //   setSearch(event.target.value)
  //   console.log(search);
  // }
  return (
    <Box className="header">
      <Box className="header-title">
          <img src="logo_light.svg" alt="QKart-icon"></img>
      </Box>
      {children && 
          children
      }
      {hasHiddenAuthButtons && 
        <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={handleClick}
        >
          Back to explore
        </Button>
      }
      {
          !hasHiddenAuthButtons && localStorage.getItem("username") && 
          <Stack direction="row" spacing={1} alignItems="center">
            <Avatar alt={localStorage.getItem("username")} src="avatar.png" />
            <p>{localStorage.getItem("username")}</p>
            <Button onClick={logout} variant="text">LOGOUT</Button>
          </Stack>
        }
        {/* <Button
          className="explore-button"
          startIcon={<ArrowBackIcon />}
          variant="text"
          onClick={handleClick}
        >
          Back to explore
        </Button> */}
        {
        !hasHiddenAuthButtons && localStorage.getItem("username")===null &&
          <Stack direction="row" spacing={1} alignItems="center">
            <Button onClick={()=>{history.push("/login", {})}}  variant="text">LOGIN</Button>
            <Button onClick={()=>{history.push("/register", {})}} variant="contained">REGISTER</Button>
          </Stack>
        }
      </Box>
    );
};

export default Header;
